import React, { ReactNode } from 'react';
import { useFormik } from 'formik';

import {
  Row,
  Col,
  Button,
  Modal,
  ListGroup,
  Form,
} from 'react-bootstrap';
import styled from 'styled-components';

import { Spin, Checkbox } from 'antd';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector } from '../../../../../utils/store.tsx';
import slice, { fields, FormikContext, initialValues, formSchema, prepareForm, prepareData } from './slice.tsx';

// enums
// import {  } from '../../../../../utils/utils.tsx';
// import {  } from '../../../../../utils/enums.tsx';

// import { ReactComponent as AlertTriangleIcon } from "../../../../../assets/icons/alert-triangle.svg";

// ----------------------------------------------------------------------

const StyledModal = styled(Modal)`
  .modal-dialog {
    min-width: 400px;
  }
`;

const StyledListGroup = styled(ListGroup)`
  overflow: auto;
  max-height: 150px;

  .list-group-item {
    border-color: var(--bs-gray-300);
  }
`;


const FormElement = ({ onConfirm }: any) => {
  const { isLoading, show, details } = useTypedSelector((state: RootState) => state.jobFormBillingJobSaveServiceSlice);
  const dispatch = useDispatch<AppDispatch>();

  React.useEffect(() => {
    if(show){
      let form = prepareForm(details, initialValues);
      setValues(form);
    }
  }, [show, details])


  const formik = useFormik({
    initialValues: initialValues,
    validateOnMount: false,
    validateOnChange: false,
    validationSchema: formSchema(null),
    onSubmit: values => {
      let form = prepareData(values);
      if(onConfirm){
        onConfirm(form, details);
      }
  
      onCancel();
    },
  });
  const { values, errors, setValues, setFieldValue, validateForm, handleSubmit }: any = formik;


  const onCancel = () => {
    let form = { remarks: ''};
    setValues(form);
    dispatch(slice.setValues(form));
    dispatch(slice.setShow({ show: false, details: null }));
    dispatch(slice.resetSlice());
  }


  const setFooter = () => {
    return <Row className='gx-12 w-100 align-items-center'>
      <Col xs={true}>
        <Checkbox
          className='sm'
          checked={values.isSaveAsGlobalService}
          onClick={(e) => {
            let checked = !values.isSaveAsGlobalService;
            setFieldValue('isSaveAsGlobalService', checked);
          }}
        >{fields.isSaveAsGlobalService.label}</Checkbox>
      </Col>
      <Col xs={'auto'}>
        <Button
          variant={'custom-outlined'}
          size={'sm'}
          onClick={(e) => {
            onCancel();
          }}
        >No</Button>
      </Col>
      <Col xs={'auto'}>
        <Button
          variant={'custom-primary'}
          size={'sm'}
          // disabled={isLoading || !(values.isSaveAsLocalService === true || values.isSaveAsGlobalService === true)}
          disabled={isLoading}
          onClick={() => {
            handleSubmit();
          }}
        >Yes</Button>
      </Col>
    </Row>
  }

  const setForm = () => {
    return <Row className={'g-12'}>
      <Col xs={12}>Do you wish to save these items to customer service list?</Col>
      <Col xs={12}>
        {(details && details.length > 0) && <StyledListGroup>
          {details.map((x: any, i: number) => {
            return <ListGroup.Item key={'jobfrom_billingjob_saveservice_item_' + i}>{x?.item?.serviceTag}</ListGroup.Item>
          })}
        </StyledListGroup>}
      </Col>
    </Row>
  }


  return <StyledModal
    className='wp-v5'
    show={show}
    onHide={() => {
      onCancel();
    }}
    backdrop={'static'}
    keyboard={false}
    enforceFocus={true}
    centered={true}
    size={'sm'}
  >
    <FormikContext.Provider value={formik}>
      <Modal.Header closeButton>
        <h6 className='fw-medium'>New service type found</h6>
      </Modal.Header>

      <Spin spinning={isLoading} wrapperClassName={'no-height'}>
        <Modal.Body className='pt-24'>{setForm()}</Modal.Body>
      </Spin>

      <Modal.Footer className='px-12'>{setFooter()}</Modal.Footer>
    </FormikContext.Provider>
  </StyledModal>
}

export default FormElement;
